/* eslint-disable import/prefer-default-export */
export const imageContainerCss = { display: 'flex', flexDirection: 'column', height: '100%' }
